/**
 * Amount/value helpers for Other Expenses — preserves US/IN locale comma rules
 * while allowing up to 2 decimal places (e.g. 12.22).
 */

const getAmountLocale = () => {
  const countryCode = String(localStorage.getItem("countrycode") || "").trim();
  const region = String(localStorage.getItem("region") || "")
    .trim()
    .toUpperCase();
  const isInLocale =
    countryCode === "+91" ||
    countryCode === "91" ||
    region === "IN" ||
    region === "INDIA";
  if (isInLocale) return "en-IN";
  return "en-US";
};

/** Strip commas; parse numeric amount. */
export const parseAmountNumber = (value) => {
  const str = String(value ?? "")
    .replace(/,/g, "")
    .trim();
  if (!str || str === ".") return 0;
  const n = Number(str);
  return Number.isFinite(n) ? n : 0;
};

/** Input: digits and one dot, max 2 digits after dot. */
export const validateAmountValue = (value) => {
  const cleaned = String(value ?? "")
    .replace(/,/g, "")
    .replace(/[^0-9.]/g, "");
  const parts = cleaned.split(".");
  if (parts.length > 1) {
    return `${parts[0]}.${parts[1].slice(0, 2)}`;
  }
  return cleaned;
};

/** Alias used in several PM tables. */
export const sanitizeDecimalInput = validateAmountValue;

/** Display with locale commas; up to 2 decimal places (does not round to integer). */
export const formatAmountComma = (num) => {
  if (num === undefined || num === null || num === "") return "";
  const str = String(num).trim();
  if (str.endsWith(".")) {
    const intPart = str.slice(0, -1);
    if (!intPart) return ".";
    const formatted = formatAmountComma(intPart);
    return formatted ? `${formatted}.` : ".";
  }
  const value = parseAmountNumber(str);
  if (!Number.isFinite(value)) return "";
  const rounded = Math.round((value + Number.EPSILON) * 100) / 100;
  return rounded.toLocaleString(getAmountLocale(), {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

/** Editable field: keep trailing "." while typing. */
export const formatAmountForInput = (value) => formatAmountComma(value);

export const sumAmountValues = (items, getValue = (item) => item?.value) =>
  (items || []).reduce(
    (sum, item) => sum + parseAmountNumber(getValue(item)),
    0
  );
